import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Row, Upload, Col, message } from "antd";
import size from "lodash/size";
import isEmpty from "lodash/isEmpty";
import { UploadLabel, UploadTitle, File, ClickUpload } from "./components";
// import { AddObligationsContextNew } from "../../context/AddObligationContextNew";
import { deleteDocument, uploadDocument } from "../../store/documents/actions";

const { Dragger } = Upload;

const Draggable = ({
  item,
  group,
  mode,
  parent_id,
  id = "",
  obligation_id = "",
  organization,
  obligations,
  setAddObligations,
  setIsSubmitButtonDisabled,
  onRemove = () => {},
  alreadyUploaded = false,
  handleFiles = () => {},
  setSingleFile,
  hasTitle = true,
  ...rest
}) => {
  const {
    label,
    subLabel,
    linkText,
    multiple,
    fileCode,
    required,
    fileAccepts,
    fileLimit
  } = item;
  const dispatchito = useDispatch();
  const [percent, setPercent] = useState(0);
  const [errorFile, setError] = useState({ name: "", error: false, fileLimit });
  const documents = item.files;
  const fileName = item.fileName;
  const user = useSelector(state => state.user);

  //use the new add_obligations context
  // const { dispatch: dispatchNewContext } = useContext(AddObligationsContextNew);

  const uploadFile = async options => {
    // console.debug("UPLOAD FILE");

    // console.debug('options: ', options);
    // console.debug('item: ', item);

    const { file } = options;

    // let rolePermissions = []
    // let userPermissions = []
    // console.debug("user inside upload", user);
    const fmData = new FormData();
    fmData.append("file", file, encodeURI(file.name));
    fmData.append("user_id", user.userId);
    // fmData.append("rolePermissions", rolePermissions)
    // fmData.append("userPermissions", userPermissions)
    fmData.append("obligation_id", obligation_id);

    dispatchito(uploadDocument({ body: fmData, user, group }));
  };

  const props = {
    name: "file",
    multiple,
    withCredentials: true,
    action: "",
    customRequest: group !== "law" ? uploadFile : null,
    openFileDialogOnClick: multiple || (!multiple && !alreadyUploaded),
    beforeUpload: file => {
      const fileExceeds = file.size > fileLimit * 1000000;

      if (fileExceeds) {
        //if multiple files upload don't show error on file component, show ant error message instead
        if (!multiple) {
          setError({ name: file.name, error: true, fileLimit });
          console.info("tried to upload file over size limit");
          return false;
        } else {
          message.error(`${file.name} is over ${fileLimit}MB.`);
        }
      } else {
        setError({ name: "", error: false });
        // const formData = new FormData();
        // formData.append("file", file);
        if (group.includes("Obligations")) return true;
      }
      return false; // do not allow upload from inside ant Upload
    },
    onChange: info => {
      console.debug("INFO: ", info);
      console.debug("UPLOAD file type", info.file.type);
      const fileExceeds = info.file.size > fileLimit * 1000000;
      if (fileExceeds) {
        // Case file is over the file limit.
        console.log("file rejected due to size");
        return;
      }
      if (group === "law") {
        info.file.type === "application/pdf"
          ? handleFiles({ files: info })
          : console.log("Not accepted", info.file.name);
      } else {
        const fileAcceptable =
          info.file.type.includes("pdf") ||
          info.file.type.includes("jpeg") ||
          info.file.type.includes("png") ||
          info.file.type.includes(".document") ||
          info.file.type.includes("ms-excel") ||
          info.file.type.includes(".sheet") ||
          info.file.type.includes("gif");
        console.debug("docsss", documents);
        const foundItem = documents.find(x => x.name === info.file.name);
        console.debug({ foundItem });
        if (foundItem == undefined && fileAcceptable)
          // handleFiles({ files: info, id: id });
          console.log("file acceptable", info.file.name);
        else {
          console.log("Not accepted", info.file.name);
          message.error(`${info.file.name} already exists.`);
        }
      }
    }
  };

  const handleDeleteDocument = (event, file) => {
    event.stopPropagation();
    event.preventDefault();
    console.debug({ file });
    console.debug({ obligation_id });

    console.debug("organization", organization);

    const doc_id = file.doc_id;
    const filename = file.name;

    dispatchito(
      deleteDocument(obligation_id, doc_id, filename, organization, user)
    );
  };

  const handleRemoveDocument = (event, file) => {
    event.stopPropagation();
    event.preventDefault();
    onRemove({files: documents});
  };

  return (
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col className="ant-drag-container">
        {label && (
          <UploadLabel
            label={label}
            subLabel={subLabel}
            linkText={linkText}
            fileCode={fileCode}
            required={required}
          />
        )}
        <Dragger
          {...props}
          {...rest}
          id={fileCode}
          className={`custom-drag ${
            documents &&
            documents[fileCode] &&
            multiple &&
            size(documents[fileCode]) > 2
              ? "with-scroll-x"
              : ""
          }`}
        >
          {hasTitle && <UploadTitle />}
          {errorFile.error ? (
            <File
              error
              file={{
                ...errorFile,
                description: "The uploaded file is too large."
              }}
              handleDeleteDocument={() => {
                setError({ name: "", error: false });
              }}
            />
          ) : !isEmpty(documents) ? (
            <div className="d-flex grid custom-drag__filelist-container">
              {Object.values(documents).map((file, index) => (
                <File
                  user={user}
                  parent_id={parent_id}
                  organization={organization}
                  id={id}
                  fileName={fileName}
                  key={index}
                  file={file}
                  handleDeleteDocument={
                    group !== "law"
                      ? handleDeleteDocument
                      : handleRemoveDocument
                  }
                  percent={percent}
                />
              ))}
            </div>
          ) : (
            <ClickUpload fileAccepts={fileAccepts} fileLimit={fileLimit} />
          )}
        </Dragger>
      </Col>
      <Col></Col>
    </Row>
  );
};

Draggable.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  linkText: PropTypes.string,
  group: PropTypes.string.isRequired,
  required: PropTypes.bool
};

export default Draggable;
